<template>
  <DxPopup @hidden="onHidden" :visible="showEpms1020Acc" :show-close-button="true" :show-title="true" :title="''"
                      width="1024" min-height="800" max-height="800" :container="container" :resizeEnabled="true">
    <v-row no-gutters class="epms1020_acc-main">
        <v-col cols="12">
          <i-card-vertical
            :headerTitle="'Accessories List'"
            :useBtnList="['btnSave']"
            @btnSave="btnSave">
              <template v-slot:body>
                <v-row no-gutters>
                  <v-col cols="12" class="px-1">
                    <i-label :label="'Part Information : '"/>
                  </v-col>
                </v-row>

                <v-row dense class="form-layout">
                  <v-col cols="12" class="pa-0">
                    <v-row no-gutters>
                      <v-col cols="2" align="center" class="pa-1 formHeader">
                        <span>Ship No</span>
                      </v-col>

                      <v-col cols="2" align="center" class="pa-1 formHeader">
                        <span>Part No</span>
                      </v-col>

                      <v-col cols="8" align="center" class="pa-1 formHeader">
                        <span>Activities/BOM Ser</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="2" align="center" class="pa-1 formData">
                        {{ shipNo }}
                      </v-col>

                      <v-col cols="2" align="center" class="pa-1 formData">
                        {{ partNo }}
                      </v-col>

                      <v-col cols="8" align="center" class="pa-1 formData">
                        {{ `${mact}-${bomSerno}` }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-if="makerCd === '10252'" no-gutters class="pt-2 px-1">
                  <i-label :label="'Group : '"/>
                  <v-col cols="3">
                    <v-select
                      v-model="selectedAccGrp"
                      :items="accGrp"
                      return-object
                      item-text="accGrpDesc"
                      item-value="accGrp"
                      single-line
                      outlined
                      dense
                      @change="accGrpChanged" />
                  </v-col>

                  <i-label :label="'List : '" class="pl-2"/>
                  <v-col cols="3">
                    <v-select
                      v-model="selectedAccCd"
                      :items="accCd"
                      return-object
                      item-text="matlAccDesc"
                      item-value="matlAcc"
                      single-line
                      outlined
                      dense />
                  </v-col>

                  <i-label :label="'Qty : '" class="pl-2"/>
                  <v-col cols="1">
                    <v-text-field 
                      v-model="qty" 
                      oninput="javascript: this.value = this.value.replace(/[.|a-z|A-Z|ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, ''); this.value = Number(this.value);"
                      dense 
                      outlined 
                      hide-details="auto"
                      maxLength="3"
                      class="qty-text"
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters class="pt-1">
                  <v-col cols="12">
                    <DxDataGrid id="epms1020Acc" 
                      :ref="epms1020AccRef"
                      :height="makerCd === '10252' ? 540 : 575"
                      :data-source="dataList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :selection="{ mode: 'none' }"
                      :sorting="{ mode: 'none' }"
                      :repaint-changes-only="true"
                    >
                      <DxEditing :use-icons="true" mode="cell" />
                      <DxPaging :enabled="true" :page-size="9" />
                      <DxPager :allowed-page-sizes="[9, 'all']" />
                      <DxColumn caption="No" data-field="id" alignment="center" :allow-editing="false" width="7%" />
                      <DxColumn caption="Accessories Info.">
                        <DxColumn caption="Code" data-field="matlAcc" alignment="center" :allow-editing="false" />
                        <DxColumn caption="Name" data-field="matlAccSpec" alignment="center" :allow-editing="false" width="38%" />
                        <DxColumn caption="Quantity" data-field="qty" alignment="right" :allow-editing="makerCd !== '10252'"
                                              :set-cell-value="setQty" data-type="string" :format="format" :editor-options="{ maxLength: 12 }" />
                        <DxColumn caption="U.Price" data-field="uprice" alignment="right" :allow-editing="false" :format="format" />
                        <DxColumn caption="Tot.Amount" data-field="amt" alignment="right" :allow-editing="false" :format="format" />
                        <DxColumn caption="" data-field="delCol" alignment="center" :allow-editing="false" cell-template="delTmpl" />
                      </DxColumn>

                      <template #delTmpl="{ data }">
                        <i-button :text="'Delete'" :isCustom="true" @click="btnDelete(data.data)" />
                      </template>
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </template>
          </i-card-vertical>
        </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getAcc, getAccCd, getAccGrp, setSubmit1020ACC, delete1020ACC } from '@/api/view/hip/common/common'
import iButton from '@/components/common/iButton'
import { getNumComma, toNum } from '@/utils/common'
import notify from 'devextreme/ui/notify'

export default {
  name: 'epms1020_acc',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    iButton
  },
  props: {
    container: {
      type: String,
      default() {
        return '.v-application'
      }
    },
    showEpms1020Acc: {
      type: Boolean,
      default() {
        return false
      }
    },
    param: {
      type: Object,
      default() {
        return {
          quotNo:'',
          shipNo: '',
          mact: '',
          bomSerno: ''
        }
      }
    }
  },
  data() {
    return {
      epms1020AccRef: 'epms1020AccRef',
      format: '#,##0.############',
      dataList: [],
      accGrp: [],
      selectedAccGrp: null,
      accCd: [],
      selectedAccCd: null,
      qty: 0,
      shipNo: '',
      mact: '',
      partNo: '',
      bomSerno: '',
      makerCd: this.$store.state.user.makerCd
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms1020AccRef)
    }
  },
  watch: {
    'showEpms1020Acc': {
      handler(value, oldValue) {
        if(value) {
          this.getData()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.dataList = []
      this.selectedAccGrp = null
      this.accGrp = []
      this.selectedAccCd = null
      this.accCd= []
      this.qty = 0
      this.shipNo = ''
      this.mact = ''
      this.partNo = ''
      this.bomSerno = ''
    },
    getData() {
      this.init()

      const param = {
        quotNo: this.param.quotNo,
        shipNo: this.param.shipNo,
        mact: this.param.mact,
        bomSerno: this.param.bomSerno,
        makerCd: this.makerCd
      }

      // console.log('param', param)

      getAcc(param).then(res => {
        // console.log('getAccRes', res)

        if(res.list && res.list.length > 0) {
          this.dataList = res.list

          for(let i = 0; i < this.dataList.length; i++) {
            this.dataList[i].uprice = toNum(this.dataList[i].uprice)
            this.dataList[i].amt = toNum(this.dataList[i].amt)
            this.dataList[i].qty = toNum(this.dataList[i].qty)
          }

          this.shipNo = res.list[0].shipNo
          this.mact = res.list[0].mact
          this.bomSerno = res.list[0].bomSerno
          this.partNo = res.list[0].partNo
        }
      })

      if(param.makerCd === '10252') {
        getAccGrp().then(res => {
          // console.log('getAccGrpRes', res)

          this.accGrp = res.list
        })
      }
    },
    accGrpChanged() {
      this.selectedAccCd = null
      this.accCd = []
      
      if(this.selectedAccGrp) {
        const param = {
          matlGrp: this.selectedAccGrp.accGrp
        }

        getAccCd(param).then(res => {
          // console.log('getAccCdRes', res)

          this.accCd = res.list
        })
      }
    },
    setQty(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].qty = val
    },
    btnSave() {
      const quotNo = this.param.quotNo
      const shipNo = this.shipNo
      const mact = this.mact
      const bomSerno = this.bomSerno
      const makerCd = this.makerCd
      const userId = this.$store.state.user.userId
      let qty = ''
      let matlAcc = ''
      let matlGrp = ''
      let param
      
      if(makerCd === '10252') {
        qty = this.qty
        matlAcc = this.selectedAccCd.matlAcc
        matlGrp = this.selectedAccGrp.accGrp

        param = [{
          quotNo,
          shipNo,
          mact,
          bomSerno,
          makerCd,
          userId,
          qty,
          matlAcc,
          matlGrp
        }]
      } else {
        param = _.cloneDeep(this.dataList)
        param.forEach(item => {
          item.userId = userId
        })
      }

      // console.log('param', param)

      setSubmit1020ACC(param).then(res => {
        const msg = res.body

        if(msg === 'Y') {
          notify(this.$t('Accessories is saved.'), 'success', 3000)
          this.getData()
          this.$emit('saveAcc')
        } else {
          this.vToastify(this.$t(msg), 'warn')
        }
      })
    },
    btnDelete(data) {
      this.vToastifyPrompt(
        this.$t(`Are you sure to delete:[${data.matlAcc}]?`),
        'info',
        current => {
          this.openLoading('searching')

          const param = {
            quotNo: data.quotNo,
            makerCd: data.makerCd,
            shipNo: data.shipNo,
            mact: data.mact,
            bomSerno: data.bomSerno,
            matlAcc: data.matlAcc
          }

          // console.log('param', param)

          delete1020ACC(param).then(res => {
            // console.log('res', res)

            if(res.success) {
              notify(this.$t('Accessories is saved.'), 'success', 3000)
              this.getData()
              this.$emit('saveAcc')
            } else {
              this.vToastify(this.$t("An error has occured while saving data...."), 'warn')
            }
          }).catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    onHidden(e) {
      this.$emit('update:showEpms1020Acc', false)
    }
  },
  mounted() {
    this.gridInstance.option('defaultPaging', false)
  }
}
</script>

<style lang="scss" scoped>
.subTitle {
  font-weight: bold;
  color: black;
}

.form-layout::v-deep > .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;

  .row {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}

.formHeader {
   background-color: rgb(223, 227, 213);
   font-weight: bold;
   color: black;
   font-size: 9pt;
 }

 .formData {
   color: black;
 }

 ::v-deep.qty-text {
   input {
     text-align: right;
   }
 }
</style>